<template>
  <v-card>
    <v-card-title>Ingrese el porcentaje</v-card-title>
    <v-card-subtitle
      >Escriba el porcentaje por el que desea aumentar los precios de los items
      seleccionados<br />El nuevo precio será el precio original más el
      porcentaje</v-card-subtitle
    >
    <v-card-text>
      <v-form @submit.prevent v-model="valid">
        <v-text-field
          v-model="input"
          outlined
          dense
          autofocus
          type="number"
          prefix="%"
          hide-details
          :rules="[
            (v) => (/^[\-0-9\.,]{1,6}$/.test(v) && +v !== 0) || 'Solo números',
          ]"
          placeholder="Escriba un porcentaje"
        ></v-text-field>
        <v-checkbox label="Redondear" v-model="round" />
        <template v-if="round">
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                label="Dirección"
                v-model="roundingData.direction"
                outlined
                dense
                :items="directions"
                hide-details
                class="mb-2"
              ></v-select>
              <v-select
                v-model="roundingData.step"
                label="A multiplo de"
                outlined
                dense
                :items="steps"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="6">
              <div class="text-center">
                <h4>Ejemplos de redondeo</h4>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th class="text-center">Inicial</th>
                      <th class="text-center">Redondeado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="s of samples" :key="s.val">
                      <td>{{ currency.symbol }}{{ s.val }}</td>
                      <td>{{ currency.symbol }}{{ s.res }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-form @submit.prevent>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text :disabled="loading" @click="$emit('close')">Cancelar</v-btn>
      <v-btn
        color="primary"
        @click="submit"
        :loading="loading"
        :disabled="!valid"
        >Aceptar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { vueData } from '../../VueData';
  import IRoundingData from '../../interfaces/IRoundingData';
  import { parseNumInput, round } from '../../utils';

  @Component
  export default class IncreasePercentageModal extends Vue {
    currency = vueData.currency;
    input: string = '';
    loading = false;
    valid = false;
    round = true;
    roundingData: IRoundingData = {
      direction: 'round',
      step: 1,
    };

    directions = [
      { value: 'round', text: 'Al más cercano' },
      { value: 'up', text: 'Hacia arriba' },
      { value: 'down', text: 'Hacia abajo' },
    ];
    steps = [
      { value: 0.25, text: '' },
      { value: 0.5, text: '' },
      { value: 1, text: '' },
      { value: 5, text: '' },
      { value: 10, text: '' },
      { value: 100, text: '' },
      { value: 1000, text: '' },
      { value: 10000, text: '' },
    ];
    samples = [
      { val: 3, res: 0 },
      { val: 14.2, res: 0 },
      { val: 45.73, res: 0 },
      { val: 1421.12, res: 0 },
      { val: 3456.12, res: 0 },
    ];

    async created() {
      this.steps.forEach((s) => (s.text = `${this.currency.symbol}${s.value}`));
    }

    @Watch('roundingData', { immediate: true, deep: true })
    onDataChanged() {
      this.updateSamples();
    }

    updateSamples() {
      for (const s of this.samples) {
        const { direction, step } = this.roundingData;
        s.res = round(s.val, step, direction);
      }
    }

    async submit() {
      this.loading = true;

      await (<Function>this.$parent.$listeners.submit)(
        parseNumInput(this.input),
        this.round ? this.roundingData : null
      );

      this.loading = false;
    }
  }
</script>
